import React from "react";
import "./style.css";

// ✅ images import (IMPORTANT)
import team1 from "./images/team1.jpg";
import team2 from "./images/team2.jpg";
import team3 from "./images/team3.jpg";

const TeamSection = () => {
  return (
    <section className="team-section py-5" style={{ marginTop: "40px" }}>
      
      {/* Background + icons */}
      <div className="bg-plus plus-left">+</div>
      <div className="bg-plus plus-right">+</div>

      <div className="container text-center">
        <div className="pq-section pq-style-1 text-center">
          <h2 className="text-center mb-3 pq-section-title">
            MEET OUR EXPERT TEAM
          </h2>
          <p className="sub-title">
            Experienced • Compassionate • Dedicated to Your Care
          </p>
        </div>

        <div className="row mt-3 g-4">

          {/* CARD 1 */}
          <div className="col-md-4">
            <div className="card-box">
              <div className="img-box">
                <img src={team1} alt="Dr Rajesh Bhardwaj" />
              </div>

              <h5>Dr. (Major) Rajesh Bhardwaj</h5>
              <p className="degree">MBBS (AFMC), MS, DNB, DLO, DHA</p>

              <span className="role">Senior ENT Consultant</span>

              <ul>
                <li>
                  <span className="icon">
                    <i className="fa-solid fa-award"></i>
                  </span>
                  35+ Years of Experience
                </li>
                <li>
                  <span className="icon">
                    <i className="fa-solid fa-users"></i>
                  </span>
                  400000+ Happy Patients
                </li>
              </ul>

              <button>VIEW PROFILE</button>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-md-4">
            <div className="card-box">
              <div className="img-box">
                <img src={team2} alt="Dr Pranshu Mehta" />
              </div>

              <h5>Dr Pranshu Mehta</h5>
              <p className="degree">(MBBS, DLO, GMHE(IIM B), FIAAT)</p>

              <span className="role">ENT Specialist / Surgeon</span>

              <ul>
                <li>
                  <span className="icon">
                    <i className="fa-solid fa-award"></i>
                  </span>
                  9+ Years of Experience
                </li>
                <li>
                  <span className="icon">
                    <i className="fa-solid fa-users"></i>
                  </span>
                  11000+ Happy Patients
                </li>
              </ul>

              <button>VIEW PROFILE</button>
            </div>
          </div>

          {/* CARD 3 */}
          <div className="col-md-4">
            <div className="card-box">
              <div className="img-box">
                <img src={team3} alt="Dr Saumya Chauhan" />
              </div>

              <h5>Dr Saumya Chauhan</h5>
              <p className="degree">MBBS, DNB otorhinolaryngology</p>

              <span className="role">ENT surgeon</span>

              <ul>
                <li>
                  <span className="icon">
                    <i className="fa-solid fa-award"></i>
                  </span>
                  3+ Years of Experience
                </li>
                <li>
                  <span className="icon">
                    <i className="fa-solid fa-users"></i>
                  </span>
                  5000+ Happy Patients
                </li>
              </ul>

              <button>VIEW PROFILE</button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TeamSection;